import classNames from 'classnames';
import { useMemo, useRef, useState } from 'react';
import {
  getCurrencyIcon,
  makeFloat,
  useClickOutside,
  useGetFreeSpins,
  useGetShortBalance
} from 'react-easyrocket';
import { useTranslation } from 'react-i18next';
import { GameArrowDown } from 'src/components/svg/GameArrowDown';
import { THREE_SECONDS } from 'src/constants';

export const GameHeaderAuthBalance = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const popupContainer = useRef(null);

  const { data: shortBalance } = useGetShortBalance({
    refetchInterval: THREE_SECONDS,
    target: 'refetchBalance',
    enabled: isOpen
  });

  const currencyIcon = getCurrencyIcon(shortBalance?.currency);

  const { freeSpins } = useGetFreeSpins({ refetchInterval: THREE_SECONDS });
  const toogleOpenState = () => {
    setIsOpen((val) => !val);
  };

  useClickOutside(popupContainer, () => setIsOpen(false));

  const userFreeSpins = useMemo(() => {
    if (freeSpins?.number === 0) return undefined;
    if (freeSpins?.number > 0 && freeSpins?.dayLimit > 0 && freeSpins?.numberDay > 0)
      return freeSpins?.numberDay;
    if (freeSpins?.number > 0 && freeSpins?.dayLimit > 0 && freeSpins?.numberDay === 0)
      return undefined;
    if (freeSpins?.number > 0 && freeSpins?.dayLimit === 0) return freeSpins?.number;
    return undefined;
  }, [freeSpins]);

  const outerCloseHandler = () => {
    setIsOpen(false);
  };

  return (
    <div className="flex items-center gap-2 relative" ref={popupContainer}>
      <button
        onClick={toogleOpenState}
        className="border border-solid rounded-full border-sgp_balance_border w-10 h-10">
        <GameArrowDown
          className={classNames(
            'h-5 w-5 transition-transform duration-300 m-auto',
            isOpen && 'rotate-180'
          )}
        />
      </button>
      {isOpen && (
        <div
          className="fixed bottom-0 left-0 right-0 top-0 z-[100] min-h-screen"
          onClick={outerCloseHandler}>
          <ul
            onClick={(e) => e.stopPropagation()}
            className="absolute 768:right-[227px] right-1 top-20 w-[283px] rounded-[12px] bg-sgp_balance_dropdown_bg text-sgp_balance_dropdown_text">
            <li className="flex items-center justify-between gap-2 px-3 py-3">
              <span className="text-base font-normal text-sgp_balance_dropdown_text">
                {t('accountWalletBalance.realBalance')}
              </span>
              <span className="text-[16px] font-bold text-sgp_balance_dropdown_currency">
                {currencyIcon} {makeFloat(shortBalance?.balanceMain)}
              </span>
            </li>
            <li className="flex items-center justify-between gap-2 px-3 py-3">
              <span className="text-base font-normal text-sgp_balance_dropdown_text">
                {t('accountWalletBalance.bonusBalance')}
              </span>
              <span className="text-[16px] font-bold text-sgp_balance_dropdown_currency">
                {currencyIcon} {makeFloat(shortBalance?.bonusCasino)}
              </span>
            </li>
            {Boolean(userFreeSpins) && (
              <>
                <li className="flex items-center justify-between gap-2 px-3 py-3">
                  <span className="text-base font-normal text-sgp_balance_dropdown_text">
                    {t('freeSpins.fs')}
                  </span>
                  <span className="text-[16px] font-bold text-sgp_balance_dropdown_currency">
                    {userFreeSpins}
                  </span>
                </li>
                <li className="flex items-center justify-between gap-2 px-3 py-3">
                  <span className="text-base font-normal text-sgp_balance_dropdown_text">
                    {t('freeSpins.fsBet')}
                  </span>
                  <span className="text-[16px] font-bold text-sgp_balance_dropdown_currency">
                    {currencyIcon} {makeFloat(freeSpins.betAmount)}
                  </span>
                </li>
              </>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};
